// extracted by mini-css-extract-plugin
export default {"hand":"VoteButton_hand__KDH6Q"};